import AdminDevices from './AdminDevices'
export default AdminDevices
